import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import add from '../../../img/add.svg';
import details from '../../../img/details.svg';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import del from '../../../img/del.svg';



export default class EventVolunteerScreen extends React.Component {

    constructor(props) {
        super(props);

        var eventid = null
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        var event = null
        
        const args = props.args === undefined ? {} : props.args

        if (args.event != undefined) {
            event = args.event
        }

        if (args.eventid !== undefined) {
            eventid = args.eventid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      eventid: eventid,
                      event: event,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      volunteers: []};

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)

        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getDataWithCritera()
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    getDataWithCritera() {

        var parameters = {}

        if (this.state.eventid) {
            parameters.eventid = this.state.eventid
        } 

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/event/volunteers', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({volunteers: res.data})
        })    
        .catch(error=>console.log(error))
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "locationCaption" :
                if (currentField === "location") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "location"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    openVolunteer(id) {
        this.props.navigate("volunteer", {caller: "event-volunteers", callargs: this.state.args, volunteer: id})
    }

    selectVolunteers() {
        this.props.navigate("event-volunteers-select", {caller: "event-volunteers", callargs: this.state.args, eventid: this.state.eventid, event: this.state.event}) 
    } 

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    deleteVolunteer(id) {
        BaseApi.delete('/event/volunteer', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: id}, withCredentials: true})
        .then(res => {
            this.getDataWithCritera()
        })    
        .catch(error=>console.log(error))
    }
    
    renderVolunteer(volunteer) {
    
        return (
            <tr
                key={volunteer.id}
                className="table-row-clickable"
                onClick={()=>this.openVolunteer(volunteer.volunteerid)}
            >
                    <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.name}</td>
                    <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.location}</td>
                    <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.phone}</td>
                    <td style={{textAlign: 'center',  padding: '4px'}}>{volunteer.occupation}</td>
                    
                    <td 
                        style={{textAlign: 'center'}}
                    >
                       <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={(e) => {
                                e.stopPropagation();          // важно: не триггерить клик по строке
                                this.deleteVolunteer(volunteer.id);
                            }}
                        >
                            <img src={del} height="14" />
                        </button>
                    </td>
            </tr>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Волонтеры"}/>
                {/* Фильтр */}
                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>
                            
                                <div className="mb-3">
                                        <label className="form-label">Имя</label>
                                    <input
                                        type="text"
                                        value={this.state.nameCriteria}
                                        onChange={this.nameCriteriaChangeHandler}
                                        className="form-control"
                                    />
                                </div>
                                   
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button className="btn btn-primary d-flex align-items-center" onClick={()=>{this.selectVolunteers()}}>
                                Добавить волонтеров
                            </button>
                        </div>

                        {/* Пагинация */}
                        <div>
                            <button className="btn btn-outline-secondary btn-sm me-2" onClick={this.prevPage}>Предыдущие</button>
                            <button className="btn btn-outline-secondary btn-sm" onClick={this.nextPage}>Следующие</button>
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="nameCaption"    
                                            className="text-start"
                                            style={{ cursor: "pointer" }}
                                            onClick={this.sortClicked}
                                        >
                                                ФИО
                                                {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                                {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                        </th>
                                        <th id="locationCaption"    
                                            className="text-start"
                                            style={{ cursor: "pointer" }}
                                            onClick={this.sortClicked}
                                        >
                                                Локация
                                                {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                                                {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                                        </th>

                                        <th id="phoneCaption"    
                                            className="text-start"
                                            style={{ cursor: "pointer" }}
                                            onClick={this.sortClicked}
                                        >
                                                Телефон
                                        </th>
                                        <th id="occupationCaptuon" 
                                            className="text-start"
                                            style={{ cursor: "pointer" }}
                                        >
                                            Занят, час.
                                        </th>   
                                        <th id = "deleteCaption" 
                                            className="text-center" 
                                            style={{ width: "40px" }}
                                        >
                                            Удалить
                                        </th>   
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.volunteers.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted py-3">
                                                Волонтеры не найдены
                                            </td>
                                        </tr>
                                    )}
                                    {this.state.volunteers.map((value, index) => this.renderVolunteer(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>       
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event-volunteers.js